import styled from "styled-components";

export const Container = styled.div`
	position: relative;
	width: 100%;

	.MuiInputBase-root.MuiInputBase-formControl {
		padding-right: 140px !important;
	}

	.MuiAutocomplete-popupIndicator:not(.Mui-disabled) .MuiSvgIcon-root {
		color: ${({ theme }) => theme.pantone2726C};
	}
`;

export const AreaCheckboxAllUserGroups = styled.div`
	position: absolute;
	display: flex;
	top: 12px;
	right: 40px;
	margin: 0;
	justify-content: center;
	align-items: center;

	.MuiFormControlLabel-root {
		margin: 0;
	}

	.MuiCheckbox-root {
		padding: 0;
	}
`;

export const InactiveTag = styled.span`
	display: inline-block;
	margin-left: 0.4rem;
	padding: 0 0.4rem;
	border-radius: 5px;
	background-color: #949494;
	color: #fff;
	font-size: 0.7rem;
	font-weight: 500;
	line-height: 1rem;
`;
